export const GET_LOCATIONS_REQUEST = 'GET_LOCATIONS_REQUEST' as const;
export const GET_LOCATIONS_SUCCESS = 'GET_LOCATIONS_SUCCESS' as const;
export const GET_LOCATIONS_ERROR = 'GET_LOCATIONS_ERROR' as const;

export const GET_RESOURCES_REQUEST = 'GET_RESOURCES_REQUEST' as const;
export const GET_RESOURCES_SUCCESS = 'GET_RESOURCES_SUCCESS' as const;
export const GET_RESOURCES_ERROR = 'GET_RESOURCES_ERROR' as const;

export const PUT_RESOURCES_REQUEST = 'PUT_RESOURCES_REQUEST' as const;
export const PUT_RESOURCES_SUCCESS = 'PUT_RESOURCES_SUCCESS' as const;
export const PUT_RESOURCES_ERROR = 'PUT_RESOURCES_ERROR' as const;
